import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";

// redux
import { useDispatch, useSelector } from "react-redux";
import { uploadCompanyLogo } from "../../../slices/apps/companySlice";

const UpdateLogoModal = ({ companyId, currentLogo }) => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");

  const { uploadLogoLoading } = useSelector((state) => state.company);

  const toggle = () => {
    setModal(!modal);
    if (modal) {
      setSelectedFile(null);
      setPreview(null);
      setError("");
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setPreview(null);
      return;
    }

    if (!file.type.match("image.*")) {
      setError("Lütfen geçerli bir resim dosyası seçiniz (jpg, png, jpeg).");
      setSelectedFile(null);
      setPreview(null);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError("Dosya boyutu 5MB'dan büyük olamaz.");
      setSelectedFile(null);
      setPreview(null);
      return;
    }

    setError("");
    setSelectedFile(file);

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
  };

  const handleSubmit = async () => {
    if (!selectedFile) {
      setError("Lütfen bir dosya seçiniz.");
      return;
    }

    await dispatch(
      uploadCompanyLogo({
        companyId: companyId,
        logo: selectedFile,
      })
    ).unwrap();

    toggle();
  };

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <React.Fragment>
      <Button
        size="sm"
        color="light"
        className="position-absolute bottom-0 end-0 rounded-circle p-1"
        style={{
          width: "30px",
          height: "30px",
          zIndex: 10,
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        }}
        onClick={(e) => {
          e.stopPropagation();
          toggle();
        }}
        title="Logoyu Güncelle"
      >
        <i className="ri-camera-fill text-dark align-middle"></i>
      </Button>

      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Firma Logosunu Güncelle</ModalHeader>
        <ModalBody>
          <Form>
            <Row className="text-center mb-4">
              <Col xs={12}>
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center bg-light border rounded"
                  style={{
                    width: "150px",
                    height: "150px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Yeni Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : currentLogo ? (
                    <img
                      src={currentLogo}
                      alt="Mevcut Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        opacity: 0.5,
                      }}
                    />
                  ) : (
                    <span className="text-muted">Logo Yok</span>
                  )}
                </div>
                {preview && (
                  <p className="text-success small fw-bold">
                    Yeni logo önizlemesi
                  </p>
                )}
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Label htmlFor="formFile" className="form-label">
                  Logo Seçiniz
                </Label>
                <Input
                  className="form-control"
                  type="file"
                  id="formFile"
                  accept="image/*"
                  onChange={onFileChange}
                  invalid={!!error}
                />
                {error && (
                  <FormFeedback className="d-block">{error}</FormFeedback>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                color="light"
                onClick={toggle}
                disabled={uploadLogoLoading}
              >
                İptal
              </Button>
              <Button
                color="primary"
                onClick={handleSubmit}
                disabled={uploadLogoLoading || !selectedFile}
              >
                {uploadLogoLoading ? (
                  <>
                    <i className="bx bx-loader bx-spin align-middle me-2"></i>
                    Yükleniyor
                  </>
                ) : (
                  <>
                    <i className="ri-save-3-line align-middle me-2"></i>
                    Kaydet
                  </>
                )}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default UpdateLogoModal;
